import React from 'react'

const DocIcon = () => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect width="64" height="64" rx="8" fill="#E3F2FD" />
                                                    <path d="M48 18L38 8H20C18.9 8 18 8.9 18 10V54C18 55.1 18.9 56 20 56H44C45.1 56 46 55.1 46 54V20L48 18Z" fill="white" stroke="#2196F3" stroke-width="2" />
                                                    <path d="M38 8V20H50" stroke="#2196F3" stroke-width="2" />
                                                    <rect x="22" y="34" width="20" height="12" rx="2" fill="#2196F3" />
                                                    <text x="32" y="44" text-anchor="middle" font-size="10" font-family="Arial" font-weight="bold" fill="white">DOC</text>
                                                </svg>
  )
}

export default DocIcon